'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Heading = require('../Heading');

var _Heading2 = _interopRequireDefault(_Heading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var H2 = (0, _styledComponents2.default)(_Heading2.default).withConfig({
  displayName: 'H2'
})(['']);

H2.propTypes = _Heading2.default.propTypes;

H2.defaultProps = _extends({}, _Heading2.default.defaultProps, { tagName: 'h2' });

H2.displayName = 'H2';

exports.default = H2;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3620/js/elements/headings/H2.js
// module id = 562
// module chunks = 177